/**
 * Bridges the backend condition-string enum (good/slight/moderate/warning/critical)
 * with the AlarmHighlighter numeric keys (1/2/3) and product color tokens.
 */

const STRING_TO_LEVEL = {
  // The healthy band was missing, so `conditionStringToLevel('good')` returned
  // null and every consumer treated a known-healthy component as "unknown" —
  // painting it grey rather than green, indistinguishable from a component
  // reporting no data at all.
  good: 1,
  normal: 1,
  healthy: 1,
  slight: 2,
  moderate: 2,
  warning: 2,
  critical: 3,
  danger: 3,
};

/** Softer alarm red for 2D severity UI (less harsh than #FF4F39). */
export const TWIN_ALARM_RED = '#FFC0BA';
export const TWIN_ALARM_RED_RGB = '255, 192, 186';

/**
 * Saturated alarm red for the 3D twin: the emissive component heatmap and the
 * event marker badge. The soft pink above reads as washed-out pink once applied
 * as a low-intensity emissive over the grey body material, so the 3D surfaces
 * use this stronger, more clearly-red hue instead.
 */
export const TWIN_TINT_RED = '#FF4040';
export const TWIN_TINT_RED_RGB = '255, 64, 64';
export const TWIN_TINT_RED_HEX = 0xff4040;

export const SEVERITY_COLORS = {
  high: TWIN_ALARM_RED,
  medium: '#F0C000',
  default: '#94A3B8',
};

export function severityHighBg(alpha) {
  return `rgba(${TWIN_ALARM_RED_RGB}, ${alpha})`;
}

export function conditionStringToLevel(str) {
  if (!str) return null;
  return STRING_TO_LEVEL[String(str).toLowerCase()] || null;
}

function classifySeverity(severity) {
  const s = (severity || '').toLowerCase();
  if (s.includes('high') || s.includes('critical')) return 'high';
  if (s.includes('medium') || s.includes('warning')) return 'medium';
  if (s.includes('low') || s.includes('info')) return 'low';
  return 'default';
}

export function severityToKey(severity) {
  return classifySeverity(severity);
}
